import { Suspense as ReactSuspense, ReactNode } from "react";
import ClientOnly from "./ClientOnly";

interface SuspenseProps {
  children: ReactNode;
  fallback?: ReactNode;
}

  /**
   * Inertia.js SSR doesn't support Suspense, causing hydration mismatches.
 
   * A "hydration mismatch" is when the server renders the Suspense boundary,
   * but then client immediately loads the actual component.
   *  
   * As a workaround, we can always delay rendering the Suspense boundary until the client side to prevent this.
   * The downside of this approach is that the lazy() loading of the component will only begin on the client-side.
   * 
   * See:
   *  https://github.com/hardcoverapp/hardcover/issues/1377
   *  https://github.com/inertiajs/inertia/issues/1671
   */

export default function Suspense({ 
  children, 
  fallback = <></>, 
}: SuspenseProps) {
  return (
    <ClientOnly fallback={fallback}>
      <ReactSuspense fallback={fallback}>
        {children}
      </ReactSuspense>
    </ClientOnly>
  );
} 